const translation = {
  password: '密码',
  searchPlaceholder: '搜索实例名称',
  createInstance: '新建实例',
  webAddress: '地址',
  unknown: '未知',
  empty_text: '暂无数据',
  columns: {
    nameAndId: '名称 / ID',
    template: '模板',
    status: '状态',
    permission: '权限',
    resourceSpec: '规格详情',
    image: '镜像',
    upsertTime: '创建/更新时间',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    tools: '快捷工具',
    action: '操作',
  },
  operations: {
    log: '日志',
    more: '更多',
    stop: '停止',
    start: '启动',
    terminal: '登录终端',
    saveImage: '保存镜像',
    editInstance: '编辑实例',
    deleteInstance: '删除实例',
    createInstance: '新建实例',
    stopInstance: '停止实例',
    startInstance: '启动实例',
  },
  network: {
    ip: 'IP地址',
    public: '公网',
    container: '容器',
    ssh: 'SSH',
  },
  permissionTag: {
    all_users: '公共共享',
    only_me: '个人私有',
    all_team_members: '团队共享',
  },
}

export default translation
